import "./homepage.style.scss";

const Homepage = () => {
  return (
    <div className="homepage">
      <div className="left">
        <h5>SO, YOU WANT TO TRAVEL TO</h5>
        <h1>space</h1>
        <p>
          Let’s face it; if you want to go to space, you might as well genuinely
          go to outer space and not hover kind of on the edge of it. Well sit
          back, and relax because we’ll give you a truly out of this world
          experience!
        </p>
      </div>
      <div className="right">
        <div className="circle__wrapper">
          <button
            onClick={() => {
              window.location.href = "/destination/Moon";
            }}
            className="circle"
          >
            explore
          </button>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
